<template>
  <div>
    <ul class="simple-menu">
      <li>
        <a href="#">Open</a>
        <ul>
          <li><a href="#" id="loadModuleButton" v-on:click="loadModuleClick">Load module</a></li>
          <li><a href="#" id="loadButton" v-on:click="loadProjectClick">Load project</a></li>
        </ul>
      </li>
      <li>
        <a href="#">Save</a>
        <ul>
          <li><a href="#" id="saveModuleButton" v-on:click="saveModuleClick">Save module</a></li>
          <li><a href="#" id="saveButton" v-on:click="saveProjectClick">Save project</a></li>
        </ul>
      </li>
      <li>
        <a href="#">Clear</a>
        <ul>
          <li><a href="#" id="clearModuleButton" v-on:click="clearModuleClick">Clear module</a></li>
          <li><a href="#" id="clearButton" v-on:click="clearAllClick">Clear all</a></li>
        </ul>
      </li>
      <li>
        <a href="#">Examples</a>
        <ul>
          <li><a href="#" id="loadExampleButton" v-on:click="loadExampleClick('basic')">Basic example</a></li>
          <li><a href="#" id="loadModuleExampleButton" v-on:click="loadExampleClick('module')">Module example</a></li>
        </ul>
      </li>
      <li>
        <a href="#" id="tabViewButton" v-on:click="openTabView">Tabular View</a>
      </li>
      <li>
        <a href="#" id="helpButton" v-on:click="helpClick">Help</a>
      </li>
      <li>
        <a href="#" id="aboutButton" v-on:click="aboutClick">About</a>
      </li>
    
      <input type="file" id="fileSelectorInput" multiple accept=".json,application/json" style="display:none" v-on:change="loadProject" />
      <input type="file" id="fileModuleSelectorInput" multiple accept=".json,application/json" style="display:none" v-on:change="loadModule" />

      <div class="inline-element">
        Sampling Number:
        <input type="number" id="samplingNumberInputField" value="10000" v-on:change="refreshEditor" />
      </div>

      <div class="inline-element">
        Period to display:
        <select id="timeSliceSelector" v-on:change="changePeriod">
          <option
            v-for="option in periods"
            v-bind:key="option"
            v-bind:value="option"
          >
            {{ option + 1 }}
          </option>
        </select>
      </div>

      <div class="inline-element">
        Number of periods:
        <input
          type="number"
          id="timeSlicesInputField"
          value="1"
          min="1"
          max="60"
          v-model="numberOfPeriod"
          v-on:change="numberOfPeriodChange"
        />
      </div>
    </ul>
  </div>
</template>

<script>
  import { ABOUT_TEXT, MAIN_MODULE_NAME } from '../../util/constants/index'
  import download from '../../util/download';
  import compile from '../../util/compile';
  import openModule from '../../util/openModule';
  import { fixDuplicatedProjectKeys, fixDuplicatedModuleKeys } from '../../util/fixDuplicatedKeys';
  import NodesData from '../../util/exportData/nodesData';
  

  import basicSampleJson from '../../assets/samples/example.json';
  import moduleSampleJson from '../../assets/samples/example_modules.json';

  import AreaPlugin from 'rete-area-plugin';
  import Vue from 'vue';
  
  let editor;
  let engine;
  let currentModule;
  let modules;
  let moduleSelector;

  export default {
    name: 'Menu',
    props: ['engine', 'editor', 'currentModule', 'modules', 'activeModule'],
    mounted () {
      engine = this.engine;
      editor = this.editor;
      currentModule = this.currentModule;
      modules = this.modules;
      moduleSelector = this.$parent.$refs.moduleSelector;

      this.$eventHub.$on('updateNodeParameter', this.updateNodeParameter); // event listener for changes of node parameters fired from the tab view
      
    },
    data () {
      return {
        selectedPeriod: this.selectedPeriod,
        numberOfPeriod: 1 // Initial number of Period
      }
    },
    computed: {
      periods() {
        return Array.from({length: this.numberOfPeriod}, (_, i) => i);
      }
    },
    methods: {
      changePeriod(e) {
        this.$emit("selectedPeriodChange", e.target.value);
        this.refreshEditor();
      },
      numberOfPeriodChange(e) {
        this.refreshEditor();
        // Write the number of generated periods into the global variable
        Vue.prototype.$globalSharedData.numberOfPeriods = e.target.value;
      },
      refreshEditor() {
        compile({
          engine,
          editor,
        });
      },
      updateNodeParameter(data) {

        // We receive the following data:
        // 'nodeID': nodeID,
        // 'period': period,
        // 'parameterKey': parameterKey,
        // 'newValue': newValue,
        // 'nodeTimeType': nodeTimeType

        // Search node
        let nodeElement = this.editor.nodes.find(n => n.id == data.nodeID);

        if (nodeElement){

          // alert(`Node with ID ${data.nodeID} found. Received values ` + data)


          if (data.nodeTimeType == 'individual'){

            // If timetype is individual, then we only need to update the value at the right spot in the array
            nodeElement.data.parameters[data.period][data.parameterKey] = data.newValue;

            // If the period is 0, we also need to update the controls
            if (data.period == 0){
              // Update the value in the control element of the visual node as well
              nodeElement.controls.get(data.parameterKey).setValue(data.newValue);
            }

            // We also need to update the parameters in nodeElement.data[parameterName]
            nodeElement.data[data.parameterKey] = data.newValue;
            
          } else if (data.nodeTimeType == 'constant') {

            // If the timetype is constant, then we only need to update nodeElement.data[parameterName]
            nodeElement.data[data.parameterKey] = data.newValue;

            // Update the value in the control element of the visual node as well
            nodeElement.controls.get(data.parameterKey).setValue(data.newValue);

            // Do we also need to update the array's 0-th position?
            // console.log('nodeElement.data.parameters', nodeElement.data.parameters)

          } else if (data.nodeTimeType == 'growthrate') {

            // If the timetype is growthrate, then we only need to update nodeElement.data[parameterName]
            nodeElement.data[data.parameterKey] = data.newValue;

            // Update the value in the control element of the visual node as well
            nodeElement.controls.get(data.parameterKey).setValue(data.newValue);

            // Do we also need to update the array's 0-th position?

          }

          // Set the value in the visible controls
          // nodeElement.controls.get(parameterKey).setValue(newValue);
          
          // Set the parameter in the data
          // nodeElement.data[parameterName] = this.parameters[0][parameterName];
          
          //write all data in array form to node
          // nodeElement.data.parameters = [...this.parameters];
                    
          compile({
            engine,
            editor,
          });
        
        } else {
          console.log('Node could not be found in this module and could, thus, not be updated.');
        }

      },
      loadModuleClick() { document.getElementById('fileModuleSelectorInput').click() },
      loadModule(event) {
        let reader = new FileReader();
        reader.onload = (e) => {
          let contents = JSON.parse(e.target.result);

          contents = fixDuplicatedModuleKeys(contents);
          
          editor.fromJSON(contents).then(() => {
              editor.view.resize();
              AreaPlugin.zoomAt(editor);
              this.refreshEditor();
            });
        };
        reader.readAsText(event.target.files[0]);
        // reset input file
        event.target.value = '';
      },
      loadProjectClick() { document.getElementById('fileSelectorInput').click() },
      loadProject(event) {

        //clear old project first
        for (let key in moduleSelector.object) {
          Vue.delete(moduleSelector.object, key);
        }

        let reader = new FileReader();
        reader.onload = (e) => {
          let contents = JSON.parse(e.target.result);

          contents = fixDuplicatedProjectKeys(contents);

          for (let key in contents) {
            Vue.set(moduleSelector.object, key, contents[key]);
          }
          moduleSelector.toggle(Object.keys(modules)[0]);
        };
        reader.readAsText(event.target.files[0]);
        // reset input file
        event.target.value = '';
      },
      saveModuleClick() {
        const fileName = prompt('Please enter a module name', 'EY-Parthenon SPURS Module');
        if (fileName == null || fileName == '') {
          // console.log('cancel save');
        } else {
          download(JSON.stringify(editor.toJSON()), fileName + '.json', 'text/json');
        }
      },
      saveProjectClick() {
        const fileName = prompt('Please enter a project name', 'EY-Parthenon SPURS Project');

        if (fileName && fileName !== '') {
          currentModule.data = editor.toJSON();
          download(JSON.stringify(modules), fileName + '.json', 'text/json');
        }
      },

      clearModuleClick() {
        // This method clears only the currently activated module
        // If the module was references in another module, this node will remain but it loses connections
        editor.fromJSON(JSON.parse('{"id":"spurs@0.1.0","nodes":{}}')).then(() => {
          editor.view.resize();
          AreaPlugin.zoomAt(editor);
          this.refreshEditor();
        });
      },

      clearAllClick() {
        // This method is supposed to delete ALL custom modules and all their content and also empty the main.module
        
        //console.log(editor)
        //console.log(modules)

        // Attempt to switch to main.module first if it is not activated already
        this.$emit("update-active-module", MAIN_MODULE_NAME);
        openModule({
          name: MAIN_MODULE_NAME,
          engine,
          editor,
          currentModule,
          modules
        });
        compile({ engine, editor });
        
        // The following loop iterates through all existing modules
        // If no custom module was defined, this would only be "main.module"
        for (let key in moduleSelector.object) {
          // console.log(key)
          Vue.delete(moduleSelector.object, key);
        }

        // Empty the main module
        // However, at this point the editor will still show the nodes and links
        Vue.set(moduleSelector.object, MAIN_MODULE_NAME, { data: {id: 'spurs@0.1.0', nodes: {}}});

        // We now open the main module (previously, the module was opened after the editor refresh, this caused problems!)
        openModule({
          name: MAIN_MODULE_NAME,
          engine,
          editor,
          currentModule,
          modules
        });

        // Now, we delete the content
        setTimeout(function(){ 
          editor.fromJSON(JSON.parse('{"id":"spurs@0.1.0","nodes":{}}')).then(() => {
            editor.view.resize();
            AreaPlugin.zoomAt(editor);
            compile({
              engine,
              editor,
            });
          }); 
        });
        
        // Reset all global variables to their defaults
        Vue.prototype.$globalHighlightArray = [];
        Vue.prototype.$globalTempHighlightArray = [];
        Vue.prototype.$globalSharedData = {
          selectedPeriod: 0, // zero-indexed
          idOfNodeThatOwnsHighlight: undefined, // this is undefined by default
          nameOfNodeThatOwnsHighlight: undefined, // this is undefined by default
          uidOfVueDistPreviewThatOwnsHighlight: undefined, // this is undefined by default
          lastSliderPositionLowerBoundAsString: undefined, // this is undefined by default
          lastSliderPositionUpperBoundAsString: undefined, // this is undefined by default
          defaultPopupName: 'Distribution details',
          klDivergenceArray: [],
          extractData: {}, // This object will be filled with information from each node when processing then
        };


      },

      loadExampleClick(selectedExample) {

        // debugger;

        let jsonData;

        if (selectedExample == "basic"){
          jsonData = basicSampleJson
        } else if (selectedExample == "module"){
          jsonData = moduleSampleJson
        }

        if (jsonData){

          //clear old project first
          Object.entries(moduleSelector.object).forEach((entry) => {
            // each entry is an array with two elements: key, and value
            Vue.delete(moduleSelector.object, entry[0]);
            // console.log('deleted ' + entry[0] )
          });

          // console.log('after delete', moduleSelector.object)
          // console.log('modules after delete', modules)
        
          for (let key2 in jsonData) {
            Vue.set(moduleSelector.object, key2, jsonData[key2]);
          }

          // This needs to be here so that main.module does not appear in the module selector
          moduleSelector.toggle(Object.keys(modules)[0]);

          // moduleSelector is a Vue component.
          // moduleSelector.object is an object that contains the name of modules as a key.
          
          //console.log(moduleSelector)
          // console.log(Object.keys(moduleSelector.object))
          // console.log(currentModule) // this is the problem: this refers to a now no longer existing module

          // console.log('modules', modules)

/*           openModule({
            name: Object.keys(moduleSelector.object)[0],
            engine,
            editor,
            currentModule,
            modules
          }); */

         /*  this.refreshEditor(); */

        }
      },

      helpClick() {
        Vue.prototype.$eventHub.$emit("showHelpPopUpEvent", true);
      },

      openTabView() {

        // console.log('modules', modules)
        // console.log(typeof modules) // object

        // Create a dictionary of node IDs and the name of the module they're in
        // This allows the TabView to als show the module in the overview
        // For this, we parse the modules object of the editor
        // The structure of modules is:
        // (1) object with module names as keys
        // (2) each module has one data object
        // (3) each data object has a nodes object
        // (4) each nodes object has the nodes with the id being the key; and the key is also in the node object again

        let nodeToModuleNameDict = {};

        for (let [moduleNameAsKey, moduleObject] of Object.entries(modules)) {
          // console.log(`${moduleNameAsKey}: ${moduleObject}`);

          // Iterate over nodes in the data.nodes object of a module
          for (let [nodeKey, nodeObject] of Object.entries(moduleObject.data.nodes)) {
            // console.log(`${nodeKey}: ${nodeObject.id}`);

            // Add node with the module name to the dictionary
            nodeToModuleNameDict[nodeKey] = moduleNameAsKey;
          }

        }

        let tabViewData = {
          nodeToModuleNameDict: nodeToModuleNameDict
        }

        Vue.prototype.$eventHub.$emit("showTabViewPopUpEvent", {showTabView: true, tabViewData: tabViewData }); 

      },
      aboutClick() {

        // TEMP test
        Vue.prototype.$eventHub.$emit("heyNodesUpdateYourPreviewsAndKL");

        // Trigger modal
        Vue.prototype.$eventHub.$emit("showModal", 
          {
            isModalShown: true, 
            modalData: {
              textAsHTML: ABOUT_TEXT,
              type: 'information',
              title: 'About'
            }
          });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .inline-element .button {
    margin-top: -.2em;
  }

  br { clear:left }

  .simple-menu {
    list-style-type: none;
    background-color: white;
    float:left;
    padding-left: 11px;
    margin: 0;
    padding: 0;
    position: fixed;
    left: 0;

    z-index: 100;
  }

  .simple-menu li {
      float: left;
  }

  .simple-menu li a {
    text-decoration: none;
    display: block;
    color: #51A7DD;
    padding: 10.5px 11px;
  }

  .simple-menu ul {
    position:absolute;
    left:-9999px;
    top:-9999px;
    list-style-type: none;
  }

  .simple-menu li:hover a{
    color: white;
  }
  .simple-menu li:hover {
    position:relative;
    background:#51A7DD;
    color: #51A7DD;
  }

  .simple-menu li:hover ul {
    left:0px;
    top:35px;
    background:#51A7DD;
    padding:0px;
    z-index: 100;
  }

  .simple-menu li:hover ul li a {
    padding:5px;
    display:block;
    width:140px;
    text-indent:15px;
    color: white;
    background-color:#51A7DD;
  }

  .simple-menu li:hover ul li a:hover {
    background:#79BAE7;
  }

  .simple-menu .inline-element{
    display: block;
    float: right;
    margin-top: 6px;
    margin-left: 20px;
  }
</style>
